"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "abbateggio": {
    "3a9a48b5": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "skipSearch": false
    }],
    "colle-della-selva": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3cc5013a": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "skipSearch": false
    }],
    "colle-di-gotte": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2b2db772": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "skipSearch": false
    }],
    "cusano": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "12735ab8": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "skipSearch": false
    }],
    "di-mezzo": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5dbef0db": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "skipSearch": false
    }],
    "le-piane": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1e4dc121": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "skipSearch": false
    }],
    "salza": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4fd59a75": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "33fa9f11": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "skipSearch": false
    }],
    "sant-agata": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "745af676": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "skipSearch": false
    }],
    "scalelle": [{
      "hkey": "10e2f967",
      "slug": "abbateggio",
      "name": "Abbateggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;